import styled from 'styled-components'

const StyledMaxButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0 3.5px;
  margin-left: 5px;
  border: none;
  border-radius: 20px;
  background: ${({ theme }) => theme.colors.primaryMuted};
  cursor: pointer;

  height: 18px;
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
`
interface ButtonProps {
  handleClick: () => void
}

const MaxButton: React.FC<ButtonProps> = ({ handleClick }) => {
  return <StyledMaxButton onClick={handleClick}>MAX</StyledMaxButton>
}

export default MaxButton
